import { Routes } from '@angular/router';

import { AdminComponent } from './components/admin/admin.component';
import { AuditDetailComponent } from './components/audit-detail/audit-detail.component';
import { MysiteComponent } from './components/mysite/mysite.component';
import { RecAndAuditsTabComponent } from './components/rec-and-audits-tab/rec-and-audits-tab.component';
import { RecommendationDetailComponent } from './components/recommendation-detail/recommendation-detail.component';

export const routes: Routes = [
  {
    path: '',
    children: [
      { path: 'recommendations/:area', component: RecAndAuditsTabComponent },
      { path: 'audits/:area', component: RecAndAuditsTabComponent },
      { path: 'audits-all/:area', component: RecAndAuditsTabComponent },
      {
        path: 'recommendations-all/:area',
        component: RecAndAuditsTabComponent
      },
      {
        path: 'recommendation_detail/:id/:tab',
        component: RecommendationDetailComponent
      },
      {
        path: 'recommendation_detail/:id',
        redirectTo: 'recommendation_detail/:id/0'
      },
      {
        path: 'audit_detail/:audit/recommendation_new/:tab',
        component: RecommendationDetailComponent
      },
      {
        path: 'audit_detail/:audit/recommendation_new',
        redirectTo: 'audit_detail/:audit/recommendation_new/0'
      },

      { path: 'audits/:area/new/:tab', component: AuditDetailComponent },
      { path: 'audits/:area/new', redirectTo: 'audits/:area/new/0' },
      { path: 'audit_detail/:id/:tab', component: AuditDetailComponent },
      { path: 'audit_detail/:id', redirectTo: 'audit_detail/:id/0' },

      { path: 'admin', component: AdminComponent },

      { path: '**', component: MysiteComponent }
    ]
  }
];
